import { Page } from '@/core/architecture'

import { EventsTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * Events Page
 * Implemented as a practical sample.
 */
export const Events: Page = () => {
  const { state, actions } = useViewModel()

  return <EventsTemplate state={state} {...actions} />
}
